"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeUpdateStream = void 0;
var api_utils_1 = require("@moralisweb3/api-utils");
var StreamNetwork_1 = require("../utils/StreamNetwork");
var IncorrectNetworkError_1 = require("../utils/IncorrectNetworkError");
var common_streams_utils_1 = require("@moralisweb3/common-streams-utils");
var makeUpdateAptosStream = function (core, baseUrl, _a) {
    var networkType = _a.networkType, options = __rest(_a, ["networkType"]);
    return new api_utils_1.OperationResolver(common_streams_utils_1.updateStreamAptosOperation, baseUrl, core).fetch(options);
};
var makeUpdateEvmStream = function (core, baseUrl, _a) {
    var networkType = _a.networkType, options = __rest(_a, ["networkType"]);
    return new api_utils_1.OperationResolver(common_streams_utils_1.updateStreamEvmOperation, baseUrl, core).fetch(options);
};
var makeUpdateStream = function (core, baseUrl) {
    return (function (updateStreamOptions) {
        switch (updateStreamOptions.networkType) {
            case StreamNetwork_1.StreamNetwork.APTOS:
                return makeUpdateAptosStream(core, baseUrl, updateStreamOptions);
            case StreamNetwork_1.StreamNetwork.EVM:
                return makeUpdateEvmStream(core, baseUrl, updateStreamOptions);
            default:
                if (updateStreamOptions.networkType === undefined) {
                    return makeUpdateEvmStream(core, baseUrl, updateStreamOptions);
                }
                throw new IncorrectNetworkError_1.IncorrectNetworkError(updateStreamOptions.networkType);
        }
    });
};
exports.makeUpdateStream = makeUpdateStream;
//# sourceMappingURL=update.js.map